import { render, staticRenderFns } from "./countLabel.vue?vue&type=template&id=64cf71bf&"
import script from "./countLabel.vue?vue&type=script&lang=js&"
export * from "./countLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports